module.exports = __webpack_public_path__ + "static/media/2022_AnnualReport_uk.a3d747b2.jpeg";